function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0h24v24H0V0z"
})), /*#__PURE__*/React.createElement("g", {
  id: "rial-symbol-currency",
  transform: "translate(-930 232)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFD465",
  cx: 942,
  cy: -220,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2A60D",
  d: "M942-209c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S948.1-209,942-209z M942-229c-5,0-9,4-9,9s4,9,9,9 s9-4,9-9S947-229,942-229z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "euro-currency-symbol",
  fill: "#A77C11",
  d: "M945.1-217.1c-0.5,0.6-1.3,0.9-2.1,1c-1.3-0.1-2.4-1-2.8-2.2h3.5 c0.3,0,0.5-0.3,0.5-0.6c0-0.3-0.2-0.5-0.5-0.5H940c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6h3.7c0.3,0,0.5-0.3,0.5-0.6s-0.2-0.5-0.5-0.5 h-3.4c0.4-1.2,1.5-2.1,2.8-2.1c0.8,0,1.6,0.4,2.1,1c0.2,0.2,0.5,0.2,0.8,0l0,0c0.2-0.2,0.2-0.6,0-0.8c-0.8-0.9-1.9-1.4-3-1.4 c-1.9,0.1-3.5,1.4-4,3.3h-1.5c-0.3,0-0.5,0.3-0.5,0.6c0,0.3,0.2,0.5,0.5,0.5h1.2c0,0.2,0,0.4,0,0.6s0,0.4,0,0.6h-1.2 c-0.3,0-0.5,0.3-0.5,0.6s0.2,0.5,0.5,0.5h1.4c0.5,1.9,2.1,3.2,4,3.3c1.1,0,2.1-0.5,2.9-1.3c0.2-0.2,0.2-0.6,0-0.8 C945.7-217.3,945.3-217.3,945.1-217.1L945.1-217.1z"
}))));

function SvgEuroCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroCoin);
export default __webpack_public_path__ + "static/media/euro_coin.176f6456.svg";
export { ForwardRef as ReactComponent };